var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { forwardRef, useContext, useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import "quill-mention/autoregister";
import { MentionBlot } from "quill-mention";
import { api } from "../../api/API";
import { css } from "@emotion/css";
import { grey } from "@mui/material/colors";
import { useSyncedRef } from "../../misc/SyncedRef";
import { BoardContext } from "./BoardContextProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export const CommentEditor = /*#__PURE__*/ forwardRef((props, ref) => {
    const placeholder = props.placeholder || "Write a comment... use @ to mention things";
    const defaultValueRef = useSyncedRef(props.defaultValue);
    const ctx = useContext(BoardContext);
    const biasProject = typeof ctx.board === "object" ? ctx.board.project : undefined;
    const containerRef = useRef(null);
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        const editorContainer = container.appendChild(container.ownerDocument.createElement('div'));
        const quill = new Quill(editorContainer, { theme: 'snow', placeholder: placeholder, modules: { toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'link']], mention: { allowedChars: /^[A-Za-z0-9#\sÅÄÖåäö]*$/, mentionDenotationChars: ["@"], dataAttributes: ['href', 'id', 'value'], mentionListClass: mentionListCss, listItemClass: listItemClass, blotName: "link_mention", source: function (searchTerm, renderList) {
                        return __awaiter(this, void 0, void 0, function* () { const res = yield api.tasks2.handleSearch({ search: searchTerm, biasProject: biasProject }); renderList(res.map(u => ({ id: u.type + ":" + u.id, value: u.display, href: "https://test.com" })), searchTerm); });
                    } } } });
        if (defaultValueRef.current) {
            quill.clipboard.dangerouslyPasteHTML(defaultValueRef.current);
        }
        ref.current = quill;
        quill.focus();
        return () => {
            ref.current = null;
            if (container) { // @ts-ignore
                container.innerHTML = '';
            }
        };
    }, [ref, placeholder, biasProject, defaultValueRef]);
    return /*#__PURE__*/ _jsx("div", { ref: containerRef });
});
const mentionListCss = css({ backgroundColor: "white", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", listStyle: "none", padding: 0 });
const listItemClass = css({ padding: 4, paddingLeft: 8, paddingRight: 8, cursor: "pointer", "&:hover": { backgroundColor: grey["100"] } });
class MentionBlotLink extends MentionBlot {
    static create(value) { let node = super.create(); node.setAttribute('href', value.href); node.setAttribute('data-mention', value.id); node.setAttribute('target', '_blank'); node.innerText = value.denotationChar + value.value; return node; }
    static formats(a, b) { return MentionBlot.formats(a, b); }
}
MentionBlotLink.blotName = "link_mention";
MentionBlotLink.tagName = 'A';
Quill.register(MentionBlotLink);
